module.exports = __webpack_public_path__ + "static/media/wishlistBanner.cbd48221.png";